import { Component, NgModule, OnInit, Input, Output, EventEmitter,
    HostListener, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';

import { ConfirmationService } from 'primeng/primeng';

import { ConstantsService } from 'app/services/constants-service';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';

import { TaskListComponent } from './tasklist/task-list.component';
import { ProcessDetailsComponent } from './processdetails/process-details.component';
import { ProcessUploadComponent } from './processupload/process-upload.component';

import { Process } from 'app/shared/models/process.model';
import { TaskDefinition } from 'app/shared/models/task-definition.model';

import { ProcessService } from './process.service';

@Component({
    selector: 'manage-processes',
    providers: [ProcessService, ConfirmationService],
    templateUrl: './process.component.html',
    styleUrls: ['./process.component.css']
})

/**
 * Component for process management.
 */
export class ProcessComponent implements OnInit {
    dialogRef: MdDialogRef<any>;
    processRecords: Process[];
    processesLoaded = false;
    currentSelectedProcess: Process;
    currentSelectedProcessId: string;

    config: MdDialogConfig = {
        disableClose: true,
        width: '',
        height: '',
        position: {
            top: '',
            bottom: '',
            left: '',
            right: ''
        }
    };

    constructor(
        private processService: ProcessService,
        private snackBarService: SnackBarService,
        private cdr: ChangeDetectorRef,
        private dialog: MdDialog,
        private confirmationService: ConfirmationService,) {
    }

    @ViewChild(TaskListComponent)
    private taskListComponent: TaskListComponent;

    ngOnInit(): void {
        // Get process list with first list item selected.
        this.getProcessList(0);
    }

    // Method to get process list.
    getProcessList(selectedProcessId) {
        this.processService.getProcesses()
            .subscribe(response => {
                this.processRecords = response;
                this.processesLoaded = true;
                if(this.processRecords.length > 0) {
                    // Highlight the selected list item in process list.
                    this.selectProcessRow(this.processRecords[selectedProcessId]);
                }
            },
            err => {
               console.log(err);
            }
        );
    }

    // Metod to return the array index of the selected process record.
    getSelectedProcessIndex(selectedProcessId) {
        let selectedProcessIndex = 0;
        for(var i = 0, len = this.processRecords.length; i < len; i++) {
            if (this.processRecords[i].id === selectedProcessId)
            {
                selectedProcessIndex = i;
            }
        }
        return selectedProcessIndex;
    }

    // Method to get executed on particular process row selection.
    selectProcessRow(processEvent) {
        let processId = '';
        if(processEvent.id)
        {
            processId = processEvent.id;
        } else if(processEvent.data.id) {
            processId = processEvent.data.id;
        }

        // Set value of currently selected list item from process list.
        this.currentSelectedProcessId = processId;
        // Get the array index of selected process list item.
        let selectedProcessIndexValue = this.getSelectedProcessIndex(processId);
        // Highlight the selected list item in process list.
        if(selectedProcessIndexValue >= 0)
        {
            this.currentSelectedProcess = this.processRecords[selectedProcessIndexValue];
        }
        // Get the task list for selected process list item
        this.taskListComponent.getTaskList(processId);
    }

    // Method to get executed on particular process row unselection.
    unselectProcessRow(processEvent) {
        // Nothing as of now. It may be updated later.
    }

    // Open process details dialog to view all process field values.
    openProcessDetailsDialog(argProcessData?: any) {
        let processId = argProcessData.id;
        this.dialogRef = this.dialog.open(ProcessDetailsComponent, this.config);
        this.dialogRef.componentInstance.argProcessDetailsData = argProcessData;
        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
            if (result) {
                this.callSnackBarService(result);
            }
        });
    }

    // Open process upload dialog to import processes file.
    openProcessUploadDialog() {
        this.dialogRef = this.dialog.open(ProcessUploadComponent, this.config);
        this.dialogRef.afterClosed().subscribe(result => {
            if (result === 'imported') {
                let selectedProcessIndexValue = this.getSelectedProcessIndex(this.currentSelectedProcessId);
                this.processRecords = this.taskListComponent.taskDefinitionRecords = [];
                this.processesLoaded = false;
                this.taskListComponent.processTasksLoaded = false;
                // Get updated process and task list.
                this.getProcessList(selectedProcessIndexValue);
                this.taskListComponent.getTaskList(this.currentSelectedProcessId);
            }
        });
    }

    // Method to display success / failure message.
    callSnackBarService(response: any) {
        this.snackBarService
            .showStatus(response,
            MessageService.PROCESS_SUCCESS,
            MessageService.PROCESS_FAILURE);
    }

    @HostListener('keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        // @todo To be updated later.
        //unsavedFormCheck(event, this.dialogRef, this.orgAddForm);
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/processes/process.component.ts